import { createElement } from "react";

export const deserialize = (html: string | undefined) => {
  if (html) {
    const document = new DOMParser().parseFromString(html, "text/html");
    return deserializer(document.body);
  } else {
    return [];
  }
};

export const deserializer = (el: HTMLElement) => {
  if (el.nodeType === Node.TEXT_NODE) {
    return el.textContent;
  } else if (el.nodeType !== Node.ELEMENT_NODE) {
    return null;
  }

  const children: any = Array.from(el.childNodes)
    .map((node) => deserializer(node as HTMLElement))
    .flat();

  switch (el.nodeName) {
    case "BODY":
      return children;
    case "BR":
      return createElement("br", {}, null);
    case "P":
      return createElement("p", {}, children);
    case "H3":
      return createElement("h3", {}, children);
    case "H2":
      return createElement("h2", {}, children);
    case "H1":
      return createElement("h1", {}, children);
    case "UL":
      return createElement("ul", {}, children);
    case "LI":
      return createElement("li", {}, children);
    case "HR":
      return createElement("hr", {}, null);
    case "IMG":
      return createElement("div", {}, [
        createElement("img", { src: el.getAttribute("src") }, null),
        createElement("span", {}, el.getAttribute("data-caption"))
      ]);
    case "A":
      return createElement("a", { href: el.getAttribute("href") }, children);
    case "B":
      return createElement("strong", {}, children);
    case "STRONG":
      return createElement("strong", {}, children);
    default:
      return children;
  }
};
